import { connect } from 'react-redux';
import { isSignedOnAsCustomer, isUserLoggedIn } from 'redux/modules/sessions/selectors';

export default component =>
  connect(
    state => ({
      isSignedOnAsCustomer: isSignedOnAsCustomer(state),
      loggedIn: isUserLoggedIn(state),
    }),
    null,
  )(component);
